import React from "react";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import HeaderPages from "../../../../component/page-components/pages-header";
import useEditCompanyProfile from "./useEditCompanyProfile.hooks";
import { IconDeleteImg, LogoNexsoft } from "../../../../asset";
import { getImgName } from "../../../../util";
import { Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import Dragger from "../../../../component/dragger/Dragger";
import ModalSuccessUpdated from "../../../../component/modal/ModalSuccessUpdated";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import checkPhoneForEdit from "../../../../helpers/checkPhoneForEdit";
import SelectSearch from "../../../../component/input/SelectSearch"
import ManagementHistory from "../../../../component/management-history/management-history";
import {t} from "i18next";

const MainEditCompanyProfile = () => {
  const {
    listCountry,
    listProvince,
    form,
    listDistrict,
    listSubDistrict,
    listUrbanVillage,
    listPostalCode,
    fileImg,
    modalFailed,
    modalSuccess,
    messageModalFailed,
    err,
    error,
    onChangeSelect,
    _actionSave,
    _onChange,
    backToDetail,
    setFileImg,
    clearCurrImg,
    setModalFailed,
    _actionOk,
    onScroll,
    onSearchDDS,
    countryKeyword,
    provinceKeyword,
    districtKeyword,
    subDistrictKeyword,
    urbanVillageKeyword,
    postalCodeKeyword,
    dropdownListLoading,
    userManagementOpen,
    setUserManagementOpen,
    convertTimestamp
  } = useEditCompanyProfile();

  return (
    <>
      <div className=" p-5 h-fit">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Company Profile`}
          menuLevel4={`Edit Company Profile`}
        />

        <div className='flex items-center justify-between my-[31px]'>
          <div className="flex items-center gap-[22px]">
            <h1 className='font-sans-bold text-2xl' id='title'>{`Company Profile`}</h1>
          </div>

          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer'
               onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}
              <strong>{form?.created_by}</strong> {t("USER_DETAIL:ON")}
              <strong>{convertTimestamp(form?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")}
              <strong>{form?.updated_by}</strong> {t("USER_DETAIL:ON")}
              <strong>{convertTimestamp(form?.updated_at, true)}</strong></p>
          </div>
        </div>

        <ManagementHistory
            id={form?.company_profile_id}
            detail={form}
            tableName={'company_profile'}
            userManagementOpen={userManagementOpen}
            setUserManagementOpen={() => setUserManagementOpen(false)}
        />

        <div className=" bg-white-100 p-5 rounded-[10px] min-h-[700px]">
          <div className=" flex flex-row gap-80">
            <div className="w-[500px]">
              <p className="font-roboto text-lg text-black-100 font-bold mb-4">
                Company Profile
              </p>

              <p className="font-roboto text-base text-black-100 font-bold mb-2">
                Company Logo <i>(Optional)</i>
              </p>
              {form?.company_logo === null ||
                form?.company_logo === undefined ||
                form?.company_logo === "" ? (
                <Dragger
                  selectedFileList={fileImg}
                  setSelectedFileList={setFileImg}
                />
              ) : (
                <div className="border-2 w-full h-[118px] px-[24px] py-[12px] border-dashed rounded-md">
                  <div className="border-2 w-full h-[90px] rounded-md flex justify-between items-center p-[12px]">
                    <div className="w-[66px] h-[66px] border ">
                      <img
                        id="company-logo"
                        className="w-[66px] h-[66px]"
                        src={
                          form?.company_logo ? form?.company_logo : LogoNexsoft
                        }
                        alt="company-logos"
                      />
                    </div>
                    <div
                      id="image-name"
                      className="font-roboto font-normal text-sm text-black-300"
                    >
                      {form?.company_logo
                        ? getImgName(form?.company_logo)
                        : "-"}
                    </div>
                    <div>
                      <img
                        id="icon-delete-images"
                        className="cursor-pointer"
                        src={IconDeleteImg}
                        alt="delete-icon"
                        onClick={clearCurrImg}
                      />
                    </div>
                  </div>
                </div>
              )}

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                GroLog Account ID
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="GroLog Account ID"
                disabled
                value={
                  form?.company_profile_id ? form?.company_profile_id : "-"
                }
                status={error?.company_profile_id ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_profile_id}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Status
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Status"
                disabled
                value={form?.company_status ? form?.company_status : "-"}
              />

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Title
              </p>
              <Select
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Title"
                options={[
                  { label: "PT", value: "PT" },
                  { label: "CV", value: "CV" },
                ]}
                onChange={(evt) => {
                  onChangeSelect("company_title", evt);
                }}
                value={form?.company_title ? form?.company_title : null}
                status={error?.company_title ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_title}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Name
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Name"
                onChange={(evt) => {
                  _onChange("company_name", evt);
                }}
                value={form?.company_name ? form?.company_name : null}
                status={error?.company_name ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_name}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Email
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Email"
                onChange={(evt) => {
                  _onChange("company_email", evt);
                }}
                value={form?.company_email ? form?.company_email : null}
                status={error?.company_email ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_email}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Phone Number
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Phone Number"
                onChange={(evt) => {
                  _onChange("company_phone", evt);
                }}
                addonBefore="+62"
                value={
                  form?.company_phone
                    ? checkPhoneForEdit(form?.company_phone)
                    : null
                }
                status={error?.company_phone ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_phone}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Fax Number <i>(Optional)</i>
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Fax Number"
                onChange={(evt) => {
                  _onChange("company_fax", evt);
                }}
                addonBefore="+62"
                value={form?.company_fax ? form?.company_fax : null}
                status={error?.company_fax ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_fax}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Tax Number
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Tax Number"
                disabled
                value={form?.company_npwp ? form?.company_npwp : null}
                status={error?.company_npwp ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_npwp}
              </div>
              
              <p className="font-roboto text-lg text-black-100 font-bold mb-4 mt-4">
                Bank Account <i>(Optional)</i>
              </p>
              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Name of Bank
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Name of Bank"
                // disabled
                value={form?.bank_name ? form?.bank_name : null}
                status={(form?.bank_account_number && !form?.bank_name) ||error?.bank_name ? "error" : null}
                
                onChange={(evt) => {
                  _onChange("bank_name", evt);
                }}
              />
              <div className="text-red-100">
                {form?.bank_account_number && !form?.bank_name ? "This Field is Required" :err ? err : error?.bank_name}
              </div>

              
              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Bank Account Number
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Bank Account Number"
                disabled={!form?.bank_name }
                onChange={(evt) => {
                  _onChange("bank_account_number", evt);
                }}
                value={form?.bank_account_number ? form?.bank_account_number : null}
                status={(!form?.bank_account_number && form?.bank_name) ||error?.bank_account_number ? "error" : null}
              />
              <div className="text-red-100">
                {!form?.bank_account_number && form?.bank_name ? "This Field is Required" :err ? err : error?.bank_account_number}
              </div>

            </div>
            <div className="w-[500px]">
              <p className="font-roboto text-lg text-black-100 font-bold mb-4">
                Company Address
              </p>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Country
              </p>
              <SelectSearch
                size="large"
                placeholder="Select Country"
                onScroll={(event) => onScroll(event, 'company_country_id')}
                keyword={countryKeyword}
                onChange={(value) => onSearchDDS(value, 'company_country_id')}
                onSelect={(value) => onChangeSelect("company_country_id", value)}
                width={500}
                options={listCountry}
                loading={dropdownListLoading}
                defaultValue={form?.company_country_id}
                value={form?.company_country_id}
                status={error?.company_country_id ? 'error' : ''}
              />
              <div className="text-red-100">
                {err ? err : error?.company_country_id}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Province
              </p>
              <SelectSearch
                size="large"
                placeholder="Select Province"
                onScroll={(event) => onScroll(event, 'company_province_id')}
                keyword={provinceKeyword}
                onChange={(value) => onSearchDDS(value, 'company_province_id')}
                onSelect={(value) => onChangeSelect("company_province_id", value)}
                width={500}
                disabled={form?.company_country_id ? false : true}
                options={listProvince}
                loading={dropdownListLoading}
                defaultValue={form?.company_province_id}
                value={form?.company_province_id}
                status={error?.company_province_id ? 'error' : ''}
              />
              <div className="text-red-100">
                {err ? err : error?.company_province_id}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company District
              </p>
              <SelectSearch
                size="large"
                placeholder="Select District"
                onScroll={(event) => onScroll(event, 'company_district_id')}
                keyword={districtKeyword}
                onChange={(value) => onSearchDDS(value, 'company_district_id')}
                onSelect={(value) => onChangeSelect("company_district_id", value)}
                width={500}
                disabled={form?.company_province_id ? false : true}
                options={listDistrict}
                loading={dropdownListLoading}
                defaultValue={form?.company_district_id}
                value={form?.company_district_id}
                status={error?.company_district_id ? 'error' : ''}
              />
              <div className="text-red-100">
                {err ? err : error?.company_district_id}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Sub District
              </p>
              <SelectSearch
                size="large"
                placeholder="Select Sub District"
                onScroll={(event) => onScroll(event, 'company_sub_district_id')}
                keyword={subDistrictKeyword}
                onChange={(value) => onSearchDDS(value, 'company_sub_district_id')}
                onSelect={(value) => onChangeSelect("company_sub_district_id", value)}
                width={500}
                disabled={form?.company_district_id ? false : true}
                options={listSubDistrict}
                loading={dropdownListLoading}
                defaultValue={form?.company_sub_district_id}
                value={form?.company_sub_district_id}
                status={error?.company_sub_district_id ? 'error' : ''}
              />
              <div className="text-red-100">
                {err ? err : error?.company_sub_district_id}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Urban Village
              </p>
              <SelectSearch
                size="large"
                placeholder="Select Urban Village"
                onScroll={(event) => onScroll(event, 'company_urban_village_id')}
                keyword={urbanVillageKeyword}
                onChange={(value) => onSearchDDS(value, 'company_urban_village_id')}
                onSelect={(value) => onChangeSelect("company_urban_village_id", value)}
                width={500}
                disabled={form?.company_sub_district_id ? false : true}
                options={listUrbanVillage}
                loading={dropdownListLoading}
                defaultValue={form?.company_urban_village_id}
                value={form?.company_urban_village_id}
                status={error?.company_urban_village_id ? 'error' : ''}
              />
              <div className="text-red-100">
                {err ? err : error?.company_urban_village_id}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Address
              </p>
              <TextArea
                rows={4}
                placeholder="Company Address"
                onChange={(evt) => _onChange("company_address_1", evt)}
                value={form?.company_address_1 ? form?.company_address_1 : null}
                status={error?.company_address_1 ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_address_1}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Address 2 <i>(Optional)</i>
              </p>
              <TextArea
                rows={4}
                placeholder="Company Address 2 (Optional)"
                onChange={(evt) => _onChange("company_address_2", evt)}
                value={form?.company_address_2 ? form?.company_address_2 : null}
                status={error?.company_address_2 ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_address_2}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Address 3 <i>(Optional)</i>
              </p>
              <TextArea
                rows={4}
                placeholder="Company Address 3 (Optional)"
                onChange={(evt) => _onChange("company_address_3", evt)}
                value={form?.company_address_3 ? form?.company_address_3 : null}
                status={error?.company_address_3 ? "error" : null}
              />
              <div className="text-red-100">
                {err ? err : error?.company_address_3}
              </div>

              <div className="flex flex-row gap-5 mt-2">
                <div className="w-[200px]">
                  <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                    Neighbourhood <i>(Optional)</i>
                  </p>
                  <Input
                    className="w-full h-[47px]"
                    size="large"
                    placeholder="Neighbourhood (Optional)"
                    onChange={(evt) => _onChange("company_neighbour", evt)}
                    maxLength={3}
                    value={
                      form?.company_neighbour ? form?.company_neighbour : null
                    }
                    status={error?.company_neighbour ? "error" : null}
                  />
                  <div className="text-red-100">
                    {err ? err : error?.company_neighbour}
                  </div>
                </div>
                <div className="w-[200px]">
                  <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                    Hamlet <i>(Optional)</i>
                  </p>
                  <Input
                    className="w-full h-[47px]"
                    size="large"
                    placeholder="Hamlet (Optional)"
                    onChange={(evt) => _onChange("company_hamlet", evt)}
                    maxLength={3}
                    value={form?.company_hamlet ? form?.company_hamlet : null}
                    status={error?.company_hamlet ? "error" : null}
                  />
                  <div className="text-red-100">
                    {err ? err : error?.company_hamlet}
                  </div>
                </div>
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Postal Code
              </p>
              <SelectSearch
                size="large"
                placeholder="Select Postal Code"
                onScroll={(event) => onScroll(event, 'company_postal_code_id')}
                keyword={postalCodeKeyword}
                onChange={(value) => onSearchDDS(value, 'company_postal_code_id')}
                onSelect={(id, value) => onChangeSelect("company_postal_code", value.label)}
                width={500}
                disabled={form?.company_urban_village_id ? false : true}
                options={listPostalCode}
                loading={dropdownListLoading}
                defaultValue={form?.company_postal_code}
                value={form?.company_postal_code}
                status={error?.company_postal_code_id ? 'error' : ''}
              />
              <div className="text-red-100">
                {err ? err : error?.company_postal_code}
              </div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Longitude <i>(Optional)</i>
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Longitude (Optional)"
                onChange={(evt) => _onChange("longitude", evt)}
                value={form?.longitude ? form?.longitude : null}
                status={error?.longitude ? "error" : null}
              />
              <div className="text-red-100">{err ? err : error?.longitude}</div>

              <p className="font-roboto text-base text-black-100 font-bold mb-2 mt-2">
                Company Latitude <i> (Optional) </i>
              </p>
              <Input
                className="w-full h-[47px]"
                size="large"
                placeholder="Company Latitude (Optional)"
                onChange={(evt) => _onChange("latitude", evt)}
                value={form?.latitude ? form?.latitude : null}
                status={error?.latitude ? "error" : null}
              />
              <div className="text-red-100">{err ? err : error?.latitude}</div>
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-end mt-5 gap-6">
          <div>
            <SecondaryButton text="Cancel" action={backToDetail} />
          </div>
          <div>
            <PrimaryButton action={_actionSave} text="Save" />
          </div>
        </div>
        <ModalSuccessUpdated isVisible={modalSuccess} onOk={_actionOk} />
        <NotifFailedSaved
          visible={modalFailed}
          message={messageModalFailed}
          action={() => {
            setModalFailed(false);
          }}
        />
      </div>
    </>
  );
};

export default MainEditCompanyProfile;
